<!--
 * @Description: 
 * @Author: DOJO
 * @Date: 2020-04-02 02:05:10
 * @LastEditTime: 2020-04-02 02:15:04
 * @LastEditors: DOJO
 -->
<template>
<div>
  <div class="loading">
    <div class="loading-con">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div class="c-r">正在努力......</div>
</div>
</template>

<script>
export default {
  name: 'laoding',
  data() {
    return {

    }
  },
  props: {
    color: String
  }
}
</script>

<style scope lang="stylus">
    .c-r
      color #FF8E00
    .loading
        display flex
        align-items center
        justify-content center
        .loading-con
            display flex
            align-items center
            justify-content center
            height 1rem
            span
                display inline-block
                width .12rem
                height 1rem
                margin 0 .08rem
                border-radius .06rem
                background: #FF8E00
                -webkit-animation: load 1s ease infinite
                &:nth-child(2)
                    -webkit-animation-delay .2s
                &:nth-child(3)
                    -webkit-animation-delay .4s
                &:nth-child(4)
                    -webkit-animation-delay .6s
                &:nth-child(5)
                    -webkit-animation-delay .8s    
    @keyframes load
        0%,100%
            height .5rem
            background #FF8E00    
        50%
            height 1rem
            background: #F10D3B     
</style>
